import script from "./transferReport.vue?vue&type=script&setup=true&lang=js"
export * from "./transferReport.vue?vue&type=script&setup=true&lang=js"

import "./transferReport.vue?vue&type=style&index=0&id=1c479c0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c479c0c"]])

export default __exports__